<template>
  <div class="container-fluid p-0">
    <div class="col-12 mb-2">
      <div class="row align-items-center text-center">
        <!--<div class="card" v-if="hasAccess">-->
        <div class="col-12 text-center">
          <button v-b-modal.createWork class="btn iconed btn-secondary"><i
            class="icon-bd-plus"></i><span>جدید</span></button>
        </div>
        <!--</div>-->
      </div>
    </div>


    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>
      <table class="table table-striped">
        <thead>
        <tr>
          <!--<th scope="col" class="text-center">عملیات</th>-->
          <th scope="col" class="text-center">ردیف</th>
          <th scope="col" class="text-center">عملیات</th>
          <th scope="col" class="text-center">نام محصول</th>
          <th scope="col" class="text-center">کدسفارش</th>
          <th scope="col" class="text-center">کد برنامه تولید</th>
          <th scope="col" class="text-center">توضیحات</th>
          <th scope="col" class="text-center">اولویت</th>
          <th scope="col" class="text-center">وضعیت فعلی</th>
          <!--<th scope="col" class="text-center">تغییر وضعیت</th>-->
          <!--<th scope="col" class="text-center">الگو</th>-->
          <th scope="col" class="text-center">تعداد</th>
          <!--<th scope="col" class="text-center">نام مشتری</th>-->
          <!--<th scope="col" class="text-center">تاریخ ایجاد</th>-->
          <!--<th scope="col" class="text-center">تاریخ تحویل</th>-->

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in worksResultPagination">
          <!--<td class="text-center">-->
          <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"-->
          <!--:class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onEditClicked(item, index)"><i-->
          <!--class="icon-bd-pencil"></i></button>-->
          <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"-->
          <!--:class="{'btn-danger': deleteButtonState === 'suspend'}" @click="showChart(item.id)"><i-->
          <!--class="fa fa-th-large"></i></button>-->
          <!--<button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"-->
          <!--:class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onDeleteClicked(item, index)"><i-->
          <!--class="icon-bd-delete"></i></button>-->
          <!--</td>-->
          <!--<th scope="row" class="text-center">{{((pageIndex - 1) * pageSize) + (index + 1)}}</th>-->
          <th scope="row" class="text-center">{{item.id}}</th>
          <th scope="row" class="text-center">
            <button class="btn btn-secondary mx-1" @click="oncahangeClicked(item)"><i class="fa fa-refresh"></i></button>
            <button class="btn btn-secondary mx-1" @click="onPrintClicked(item)"><i class="fa fa-print"></i></button>
            <button class="btn btn-secondary mx-1" @click="onDeleteClicked(item)"><i class="fa fa-trash"></i></button>
          </th>
          <td class="text-center">{{item.productName}}</td>
          <td class="text-center">{{checkNullable(item.orderCode)}}</td>
          <td class="text-center">{{item.productOrderCode}}</td>
          <td class="text-center">{{item.workDescription}}</td>
          <td class="text-center">{{item.priorityName}}</td>
          <td class="text-center">{{item.statusName}}</td>

          <!--<td class="text-center">{{item.patternName}}</td>-->
          <td class="text-center">{{item.workCount}}</td>
          <!--<td class="text-center">{{checkNullable(item.orderCustomerName)}}</td>-->
          <!--<td class="text-center">{{checkNullable(changeDateFormat(item.orderDate))}}</td>-->
          <!--<td class="text-center">{{checkNullable(changeDateFormat(item.orderDeliveryDate))}}</td>-->
        </tr>
        </tbody>
      </table>

      <div class="col-12" v-if="showPagination">
        <b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"
                      @input="nextPage(pageIndex)"/>
      </div>

      <!--  <div class="col-12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @input="onWorksPaginationChange"
            :per-page="pagination.pageSize"
          ></b-pagination>
        </div>-->
    </div>
    <!-------------------------------------------------------------------------------->
    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="selectProductModal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onSelectProductOk"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowSelect="selectProduct"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="changeModal"
      title="تغییر وضعیت"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onOk"
    >
      <div class="row text-center">
        <div class="col-6 text-center">
          <span>
            تغییر وضعیت
            {{selectedWork !== undefined ? selectedWork.productName !== undefined ?selectedWork.productName:'' : ''}}
            وضعیت فعلی
            {{selectedWork !== undefined ? selectedWork.statusName !== undefined ?selectedWork.statusName:'' :''}}
          </span>
        </div>
        <div class="col-6 input-group">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>انتخاب وضعیت</span>
            </div>
            <vs-select
              ref="selectedProductPattern"
              :isHeader="true"
              :data="statusNames"
              :selectedVal="statusName.name"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="statusSelect"
            ></vs-select>
            <!--style="max-width:70%;"-->
            <!--v-if="!sellOnly && mode!=='view'"-->
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="createWork"
      ref="createWork"
      size="lg"
      title="تعریف کار جدید"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >

      <div class="row mb-2">

        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام کالا</span>
              </div>
            </div>
            <input
              v-model="product.name"
              type="text"
              class="form-control"
              @click="openProductModal"
              placeholder="ابتدا کالا را انتخاب کنید"
              readonly
            >
            <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
          </div>
        </div>

      </div>
      <div class="row mb-2">
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب الگو</span>
              </div>
              <!--<input-->
              <!--readonly="readonly"-->
              <!--v-model="selectedProductPattern.name"-->
              <!--type="text"-->
              <!--class="form-control"-->
              <!--&gt;-->
              <!--v-if="sellOnly||mode==='view'"-->
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="productPattern"
                :selectedVal="productPattern.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="voucherTitleSelect"
              ></vs-select>
              <!--style="max-width:70%;"-->
              <!--v-if="!sellOnly && mode!=='view'"-->
            </div>
          </div>
        </div>


      </div>
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>تعداد</span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="productCount">
            <!--:readonly="mode==='view'"-->
            <!--v-model="voucherModel.invoiceNumber"-->
            <!--type="text"-->
            <!--class="form-control"-->
            <!--&gt;-->
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>اولویت</span>
              </div>
            </div>

            <vs-select
              ref="selectedPriority"
              :isHeader="true"
              :data="priority"
              :selectedVal="priority.title"
              :header="{label:'title'}"
              :mode="'edit'"
              @dataChanged="priorityTitleSelect"
              style="max-width:50% !important; "
            ></vs-select>
            <!--v-if="!sellOnly && mode!=='view'"-->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>دستورات کار </span>
            </div>
          </div>
          <input type="text" class="form-control" v-model="productDescription">
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>


    </b-modal>

    <b-modal
      ref="showWorkPattern"
      id="show-work-pattern"
      size="lg"
      title="الگوی محصول"
      ok-title="بستن"
      ok-only
    >
      <div class="row">
        <div class="col-2 mt-3">
          <div class="col mt-1">
            <span class="badge badge-warning" style="background-color: #FF8F00; font-size: 10px;">درصف انتظار</span>
          </div>
          <div class="col mt-1">
            <span class="badge badge-success" style="background-color: #9E9D24; color: black; font-size: 10px">درحال انجام</span>
          </div>
          <div class="col mt-1">
            <span class="badge badge-success" style="background-color: #2E7D32; font-size: 10px">تکمیل شده</span>
          </div>
          <div class="col mt-1">
              <span class="badge badge-info text-white"
                    style="background-color: #0277BD; font-size: 10px;">تایید شده</span>
          </div>
          <div class="col mt-1">
            <span class="badge badge-primary" style="background-color: #deddff; font-size: 10px">غیرفعال</span>
          </div>
          <div class="col mt-1">
            <span class="badge badge-danger" style="background-color: #c62828; font-size: 10px">مشکل</span>
          </div>
        </div>
        <div class="col-10">
          <div>
            <vue-mermaid class='mermaid align-items-center d-flex justify-content-center' :nodes="flowchartData"
                         type="graph LR" @nodeClick="editNode"></vue-mermaid>
          </div>
        </div>

      </div>

    </b-modal>

    <!------------------------------------------------------>
    <b-modal
      id="setWorkCount"
      ref="setWorkCount"
      size="lg"
      title="گزارش تعداد کار"
      ok-title="تایید"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkWorkCount"
    >

      <div class="row mb-2">
        <label class="p-2">لطفا به سوال زیر با دقت پاسخ دهید :</label>
      </div>
      <div class="row mb-2">

        <div class="input-group col-8  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>چه تعداد از {{this.mainWorkCount}} عدد کار را میخواهید تغییر وضعیت دهید؟ </span>
            </div>
          </div>
          <input type="number" class="form-control" v-model="answerWorkCount">
        </div>

        <div class="input-group col-4 mb-2">
          <div class="input-group-prepend custom w-100">
            <div class="input-group-text">
              <span>اپراتور</span>
            </div>
            <vs-select
              ref="selectedProductPattern"
              :isHeader="true"
              :data="users"
              :selectedVal="selectedUser.name"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="userSelect"
            ></vs-select>
          </div>
        </div>

        <div class="input-group col-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>شروع کار</span>
            </div>
          </div>
          <input
            v-show=false
            readonly="readonly"
            v-model="startDate"
            type="text"
            class="form-control"
          >
          <date-picker
            v-show=true
            type="datetime"
            :auto-submit="true"
            format="YYYY-MM-DD HH:mm"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="startDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <div class="input-group col-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>پایان کار</span>
            </div>
          </div>
          <input
            v-show=false
            readonly="readonly"
            v-model="endDate"
            type="text"
            class="form-control"
          >
          <date-picker
            v-show=true
            type="datetime"

            :auto-submit="true"
            format="YYYY-MM-DD HH:mm"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="endDate"
                class="form-control date-input"
                @click="toggleEndDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <div class="input-group col-12  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <input type="text" class="form-control" v-model="workReport.description">
        </div>

      </div>

    </b-modal>

    <!------------------------------------------------------>
    <!------------------------------------------------------>
    <b-modal
      id="setProblemState"
      ref="setProblemState"
      size="lg"
      title="گزارش توقف کار"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleProblemOk"
    >

      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب نوع وقفه</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="productTypes"
                :selectedVal="productTypes.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="problemTypeSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب وقفه</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="workProblem"
                :selectedVal="workProblem.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="workProblemSelect"
              ></vs-select>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات وقفه</span>
            </div>
          </div>
          <!--<input id="problemdescription" type="text" class="form-control" v-model="workProblem.description" readonly="readonly" >-->
          <label class="form-control">{{ workProblemDescription }}</label>
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>


    </b-modal>
    <!------------------------------------------------------>
    <b-modal
      id="setDamageState"
      ref="setDamageState"
      size="lg"
      title="ثبت ضایعات"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="damageOk"
    >

      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom w-100">
              <div class="input-group-text">
                <span>انتخاب علت ضایعات</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="damageTypes"
                :selectedVal="damageTypes.name"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="damageTypeSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom w-100">
              <div class="input-group-text">
                <span>انتخاب کالا</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="products"
                :selectedVal="products.materialName"
                :header="{label:'materialName'}"
                :mode="'edit'"
                @dataChanged="productSelect"
              ></vs-select>
            </div>
          </div>
        </div>

      </div>
      <div class="row mb-2">
        <div class="input-group col-sm-6 mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>تعداد</span>
            </div>
          </div>
          <input type="number" class="form-control" v-model="damageProduct.value">
          <!--<label class="form-control">{{ damageProduct.value }}</label>-->
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
        <div class="input-group col-sm-6  mb-2">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <input type="text" class="form-control" v-model=" damageProduct.description">
          <!--<label class="form-control">{{ damageProduct.description }}</label>-->
          <!--:readonly="mode==='view'"-->
          <!--v-model="voucherModel.description"-->
          <!--type="text"-->
          <!--class="form-control"-->
          <!--&gt;-->
        </div>
      </div>


    </b-modal>
    <!------------------------------------------------------>


    <!--      PRINT                 -->
    <div id="printMe" style="display: none">
      <div class="row m-2 p-2 border text-right">
        <div class="col-2"></div>
        <div class="col-8 text-center font-2xl">دستور تولید</div>
        <div class="col-2 text-center font-weight-bold">{{printItem.date}}</div>
      </div>
      <div class="row m-2 p-2 border text-right">

        <div class="col-2">نام کالا :</div>
        <div class="col-4 font-weight-bold">{{printItem.productName}}</div>

        <div class="col-1">تعداد :</div>
        <div class="col-1 font-weight-bold">{{printItem.workCount}}</div>

        <div class="col-1">اولویت :</div>
        <div class="col-2 font-weight-bold">{{printItem.workPriority}}</div>

      </div>

      <div class="row m-2 p-2 border text-right">

        <div class="col-2 ">کد برنامه :</div>
        <div class="col-1 p-0 font-weight-bold">{{printItem.productOrderCode}}</div>

        <div class="col-2 ">کد سفارش :</div>
        <div class="col-1 p-0 font-weight-bold">{{printItem.orderCode}}</div>


        <div class="col-2 ">توضیحات :</div>
        <div class="col-4 p-0 font-weight-bold">{{printItem.orderDescription}}</div>

      </div>

      <div class="row m-2 p-2 border text-right">
        <div class="col-2">دستورات کار :</div>
        <div class="col-10 font-weight-bold">{{printItem.workDescription}}</div>
      </div>

      <hr/>
      <div class="row border mx-2  text-right">
        <div class="col-2 p-3 border-bottom">کارمند :</div>
        <div class="col-2 p-3 border-bottom font-weight-bold"></div>
        <div class="col-2 p-3 border-bottom border-right">سرپرست :</div>
        <div class="col-2 p-3 border-bottom font-weight-bold"></div>
        <div class="col-2 p-3 border-bottom border-right">مدیر :</div>
        <div class="col-2 p-3 border-bottom font-weight-bold"></div>

        <div class="col-4 p-3">محل امضاء :</div>
        <div class="col-4 p-3 border-right">محل امضاء :</div>
        <div class="col-4 p-3 border-right">محل امضاء :</div>

        <div class="col-4"><i style="visibility: hidden">www</i></div>
        <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
        <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
        <div class="col-4"><i style="visibility: hidden">www</i></div>
        <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
        <div class="col-4 border-right"><i style="visibility: hidden">www</i></div>
      </div>
    </div>
    <!--      PRINT                 -->

  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";

  export default {
    name: "product-patterns",
    props: {},
    components: {
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {
        workReport: {
          id: [],
          items: [],
          start: "",
          end: "",
          userId: 0,
          description: "",
          problemId:null
        },
        dateClicked: 0,
        productTypes: [],
        workProblem: [],
        workProblemId: 0,
        workProblemDescription: "",
        isLoading: false,
        hasAccess: true,
        printItem: {},
        access: {},
        allWorks: [],
        deleteButtonState: "primary",
        date: '',
        flowchartData: [],
        stateResult: [],
        rows: 0,
        pageSize: 12,
        pageIndex: 1,
        showPagination: true,
        worksResultPagination: [],
        priorityName: "",
        statusName: "",
        answerWorkCount: 0,
        mainWorkCount: 0,

        product: {},
        productCount: 0,
        productDescription: "",
        productPattern: [],
        priority: [],
        startDate: "",
        endDate: "",
        users: [],
        selectedUser: {name: ""},
        statusNames: [
          {
            id: 0,
            name: "ضایعات",
          },
          {
            id: 1,
            name: "تایید نهایی",
          },
          {
            id: 2,
            name: "توقف",
          },
          {
            id: 3,
            name: "در انتظار",
          },

        ],
        selectedProductPattern:
          {
            id: 0,
            name: null,

          },
        selectedPriority:
          {
            title: null,
            value: 0,

          },
        parameters: {
          count: 0,
          priority: 0,
          stop: false,
          description: "",
          patternId: 0,
          productId: 0
        },
        newWorkSystem: [],

        damageTypes: [],
        damageType: {
          name: "",
        },
        products: [],
        selectedProduct: {
          materialName: "",
        },
        damageValue: 0,
        damageDescription: "",
        damageProduct: {
          damageTypeId: 0,
          companyId: 0,
          productId: 0,
          workId: 0,
          value: 0.0,
          description: "",
          isMain: false,
        },
        selectedWork: {},
        modalStatus: {},
        workId: 0,
        questionIndex: 0,
        productTypesId: 0,
        answerList: [],
        questionlist: [],
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
      new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
        this.priority = response.data;
        // console.log(response.data)
      }).catch((error) => {
        console.log(error)
      });
      this.pageSize = 12;
      this.pageIndex = 1;
      this.rows = 0;
      this.getAllWorks();
      this.getdamageType();
      this.getUsers();
    },
    methods: {
      problemTypeSelect(prop, data) {
        this.productTypesId = data.id;
        new BaseService('WorkProblems', '/GetProblemsByTypeId/' + this.productTypesId).getList().then((response) => {
          // Utils.handleErrorWithNotification("کار با موفقیت تعریف شد", this.$noty);
          // this.$noty.success("وضعیت با موفقیت تغییر کرد");

          this.workProblem = response.data;
          if (this.workProblem <= 0) {
            Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          }
        }).catch((error) => {
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      workProblemSelect(prop, data) {
        this.workProblemId = data.id;
        this.workProblemDescription = data.description;

        // document.id(problemdescription).text = data.description;
        // this.$set(this.problemdescription);
        // #problemdescription.text = data.description;
        // this.parameters.priority = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      handleOkWorkCount() {
        // console.log(this.workId);
        // console.log(this.allWorks[this.allWorkIndex]);
        // if (this.answerWorkCount > this.allWorks[this.allWorkIndex].workCount) {
        //   Utils.handleErrorWithNotification("تعداد کار نمیتواند از تعداد اصلی بیشتر یاشد. لطفا با دقت پاسخ دهید", this.$noty);
        //   this.getAllWorks();
        // } else
        if (this.answerWorkCount < 1) {
          Utils.handleErrorWithNotification("تعداد کار نمیتواند کمتر از یک عدد باشد. لطفا با دقت پاسخ دهید", this.$noty);
          this.getAllWorks();
        } else if (this.workReport.userId===0) {
          Utils.handleErrorWithNotification("لطفا اپراتور را انتخاب کنید", this.$noty);
          this.getAllWorks();
         } else if (this.workReport.start==="") {
          Utils.handleErrorWithNotification("لطفا تاریخ و ساعت شروع کار را انتخاب کنید", this.$noty);
          this.getAllWorks();
         } else if (this.workReport.end==="") {
          Utils.handleErrorWithNotification("لطفا تاریخ و ساعت پایان کار را انتخاب کنید", this.$noty);
          this.getAllWorks();
        } else {
          this.changeWorkStatus();
        }


      },
      changeWorkStatus() {
        var workIdess = [];
        if (this.answerWorkCount === -1) {
          workIdess.push(this.workId)
          workIdess.push(1)
        } else {
          // for (var i = 0; i < this.answerWorkCount; i++) {
          //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
          // }
          workIdess.push(this.workId);
          workIdess.push(this.answerWorkCount);
        }
        let updateWork = {
          id: workIdess,
        };
        // console.log(updateWork);
        // let id = event.item.dataset.id;
        if (this.modalStatus === "inqueue") {
          new BaseService('Works', '/InQueueWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }
        if (this.modalStatus === "doing") {
          new BaseService('Works', '/DoingWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }
        if (this.modalStatus === "done") {
          new BaseService('Works', '/DoneWorkState').update(updateWork).then((response) => {
            this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.getAllWorks();
          }).catch((error) => {
            console.log(error)
            this.getAllWorks();
          });
        }

        if (this.modalStatus === "problem") {
          // this.setProblemState;
          this.$refs['setProblemState'].show();
          new BaseService('WorkProblems', '/GetProblemTypes').getList().then((response) => {
            // Utils.handleErrorWithNotification("کار با موفقیت تعریف شد", this.$noty);
            // this.$noty.success("وضعیت با موفقیت تغییر کرد");

            this.productTypes = response.data;
            if (this.productTypes <= 0) {
              Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
              this.getAllWorks();
            }
          }).catch((error) => {
            Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
            console.log(error)
            this.getAllWorks();
          });
        }

        if (this.modalStatus === "confirm") {
          this.questionIndex = 0;
          new BaseService('Works', '/GetConfirmForm/' + this.workId).getList().then((response) => {
            // this.$noty.success("وضعیت با موفقیت تغییر کرد");
            this.questionlist = response.data;
            if (this.questionlist.length > 0) {
              // this.makeQuestion();
              // this.$refs['setQuestionState'].show();
              this.noQuestion();
            }
            // console.log(response.data);
          }).catch((error) => {
            console.log(error)
          });

        }

      },
      noQuestion() {

        var workIdess = [];
        if (this.answerWorkCount === -1) {
          workIdess.push(this.workId)
          workIdess.push(1)
        } else {
          // for (var i = 0; i < this.answerWorkCount; i++) {
          //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
          // }
          workIdess.push(this.workId);
          workIdess.push(this.answerWorkCount);
        }

        for (const qs of this.questionlist) {


          const items = {
            productId: qs.productId,
            confirmFormId: qs.confirmFormId,
            answer: qs.percentage * workIdess[1],
          };
          this.answerList.push(items);
          this.questionIndex++;
        }

        // let answerModel = {
        //   id: workIdess,
        //   items: this.answerList
        // };
        this.workReport.id = workIdess;
        this.workReport.items = this.answerList;

        this.workId = 0;
        this.answerList = [];
        this.isLoading = true;
        new BaseService('Works', '/ConfirmWorkState_New').update(this.workReport).then((response) => {
          this.$noty.success("وضعیت با موفقیت تغییر کرد");

          this.getAllWorks();
          // console.log(response.data);
        }).catch((error) => {
          console.log(error)
          this.questionIndex++;
          // this.makeQuestion();
          this.getAllWorks();
        });

      },

      onDeleteClicked(item) {
        if (confirm("آیا از حذف کارها اطمینان دارید؟ فقط کارهای در انتظار تولید حذف میشوند")) {
          let id = item.id;
          new BaseService('works', `/Removework/${id}`).delete().then((response) => {
            this.$noty.success("کارها با موفقیت حذف شدند");
            this.getAllWorks();
          }).catch((error) => {
            this.$noty.error("متاسفانه خطایی روی داده است");
            console.log(error);
            this.getAllWorks();
          })
        }
      },
      onPrintClicked(item) {
        this.printItem = item;
        switch (this.printItem.workPriority) {
          case 0:
            this.printItem.workPriority = "اولویت کم";
            break;
          case 1:
            this.printItem.workPriority = "اولویت متوسط";
            break;
          case 2:
            this.printItem.workPriority = "اولویت زیاد";
            break;
        }
        let date = Moment(this.printItem.startedStatusTime, "YYYY-MM-DD hh:mm:ss");
        this.printItem.date = date.format(" hh:mm jYYYY/jMM/jDD");
        setTimeout(() => {
          const title = document.title;
          document.title = "دستور تولید : " + this.printItem.workId;
          this.$htmlToPaper('printMe');
          document.title = title;
        }, 200);
      },
      getdamageType() {
        // this.isLoading = true;
        new BaseService('WorkProblems', '/GetdamageTypes').getList().then((response) => {
          // console.log(response.data);
          this.damageTypes = response.data;
          // this.isLoading = false;
        }).catch((error) => {
          // this.isLoading = false;
          console.log(error)
        })
      },
      oncahangeClicked(item) {
        console.log(item);
        this.selectedWork = item;
        this.$refs['changeModal'].show();
      },
      onOk() {
      },
      openDamageModal() {
        console.log(this.$refs['setDamageState']);
        this.$refs['setDamageState'].show();
      },
      addDamage(work) {
        this.isLoading = true;
        console.log(work)
        let param = {
          productId: work.productId
        };
        new BaseService('Materials').getList(param).then((response) => {
          this.products = response.data.data;
          for (let i of this.products) {
            i.workId = work.id;
          }
          let mainProd = {
            id: null,
            materialName: work.productName,
            productId: work.productId,
            workId: work.id
          };
          this.products.push(mainProd);
          this.isLoading = false;
          setTimeout(() => {
            this.openDamageModal();
          }, 150);
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      damageTypeSelect(prop, data) {
        if (data !== null) {
          this.damageType = data;
          this.damageProduct.damageTypeId = data.id;
        }
      },
      productSelect(prop, data) {
        if (data !== null) {
          this.selectedProduct = data;
          this.damageProduct.workId = data.workId;
          if (data.id === null) {
            this.damageProduct.productId = data.productId;
            this.damageProduct.isMain = true;
          } else {

            this.damageProduct.productId = data.materialId;
          }
        }
        console.log(this.damageProduct)
      },
      damageOk() {

        if (this.damageProduct.productId === undefined || this.damageProduct.productId === 0) {
          this.$noty.error("لطفا محصول را انتخاب کنید");
        } else if (this.damageProduct.damageTypeId === undefined || this.damageProduct.damageTypeId === 0) {
          this.$noty.error("لطفا علت ضایعات شدن را انتخاب کنید");
        } else if (this.damageProduct.value === 0) {
          this.$noty.error("لطفا تعداد محصول را انتخاب کنید");
        } else {

          this.isLoading = true;
          // this.damageProduct.companyId = localStorage.getItem("companyId");
          new BaseService('WorkProblems/CreateDamageProducts').create(this.damageProduct).then((response) => {
            this.isLoading = false;
            this.$noty.success(response.data.value);
            this.getAllWorks();
          }).catch((error) => {
            this.getAllWorks();
            this.isLoading = false;
            this.$noty.error(error.data.value);
          });

        }
      },
      voucherTitleSelect(prop, data) {
        // console.log(this.priority);
        this.parameters.patternId = data.id;
        // console.log(this.parameters.patternId);

        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      statusSelect(prop, data) {
        this.$refs['changeModal'].hide();
        this.modalStatus = status;
        this.workId = this.selectedWork.id;
        if (data.id === 1) {
          this.modalStatus = "confirm"
        }
        if (data.id === 2) {
          this.modalStatus = "problem"
        }
        if (data.id === 3) {
          this.modalStatus = "inqueue"
        }
        if (data.id === 0) {
          this.addDamage(this.selectedWork);
        } else {
          // if (this.allWorks[i].workIdes.length > 1) {
          if (this.selectedWork.workCount > 1) {
            this.mainWorkCount = this.selectedWork.workCount;

            this.answerWorkCount = 0;
            this.$refs['setWorkCount'].show();
          } else {
            this.answerWorkCount = -1;
            this.changeWorkStatus();
          }
        }

      },
      priorityTitleSelect(prop, data) {
        this.parameters.priority = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      handleProblemOk() {
        let paramOk = true;
        if (this.workProblemId <= 0) {
          Utils.handleErrorWithNotification("لطفا نوع وقفه را انتخاب کنید", this.$noty);
          paramOk = false;
        }
        if (paramOk) {
          var workIdess = [];
          if (this.answerWorkCount === -1) {
            workIdess.push(this.workId)
            workIdess.push(1)
          } else {
            // for (var i = 0; i < this.answerWorkCount; i++) {
            //   workIdess.push(this.allWorks[this.allWorkIndex].workIdes[i]);
            // }
            workIdess.push(this.workId)
            workIdess.push(this.answerWorkCount)
          }
          let updateWork = {
            id: workIdess,
            problemId: this.workProblemId,
          };
          this.workReport.id = workIdess;
          // this.workReport.items = this.answerList;
          this.workReport.problemId = this.workProblemId;
          // console.log(this.workReport)
          new BaseService('Works', '/ProblemWorkState').update(this.workReport).then((response) => {
            this.$noty.success("وقفه با موفقیت ثبت شد");
            this.getAllWorks();
            // console.log(response.data)
          }).catch((error) => {
            console.log(error)
          });
        }


        // Prevent modal from closing
        // bvModalEvt.preventDefault();
        // // Trigger submit handler
        // this.handleSubmit();
        // if (this.editProblemTypeFlag === false) {
        //   this.createProblemType(this.name)
        // } else {
        //   this.updateProblemType(this.problemType);
        //   this.editProblemTypeFlag = false;
        // }
      },

      handleOk(bvModalEvt) {
        let paramOk = true;
        if (this.productCount <= 0) {
          Utils.handleErrorWithNotification("لطفا تعداد محصول را وارد کنید", this.$noty);
          paramOk = false;
        }
        if (this.parameters.patternId <= 0) {
          Utils.handleErrorWithNotification("لطفا الگوی محصول را وارد کنید", this.$noty);
          paramOk = false;
        }
        if (this.product.id <= 0) {
          Utils.handleErrorWithNotification("لطفا محصول را وارد کنید", this.$noty);
          paramOk = false;
        }
        if (paramOk) {
          this.parameters.count = this.productCount;
          // this.parameters.priority = this.priority.value;
          this.parameters.description = this.productDescription;
          this.parameters.productId = this.product.id;
          // console.log(this.parameters);
          new BaseService('Works', '/CreateWork').create(this.parameters).then((response) => {
            this.$noty.success("کار با موفقیت ثبت شد");
            this.getAllWorks();
            // console.log(response.data)
          }).catch((error) => {
            this.getAllWorks();
            console.log(error)
          });
        }


        // Prevent modal from closing
        // bvModalEvt.preventDefault();
        // // Trigger submit handler
        // this.handleSubmit();
        // if (this.editProblemTypeFlag === false) {
        //   this.createProblemType(this.name)
        // } else {
        //   this.updateProblemType(this.problemType);
        //   this.editProblemTypeFlag = false;
        // }
      },
      resetModal() {
        this.name = '';
        this.nameState = null;
      },
      getKardex: function (id, togglePagination = false) {
        if (togglePagination) {
          this.showPagination = false;
        }
        new BaseService('Voucher', `/GetKardex/${id}`).getList().then((response) => {
          // console.log(response.data);
          this.kardexResult = response.data;
          this.rows = this.kardexResult.length;
          this.calcStock();
          this.nextPage(this.pageIndex);
        }).catch((error) => {
          console.log(error)
        }).then(() => {
          if (togglePagination) {
            this.showPagination = true;
          }
        })
      },
      onSelectProductOk() {
        this.hideModal();
        this.show = false;
        let self = this;
        setTimeout(() => {
          this.show = true;
        }, 50);
        setTimeout(() => {
          let data = self.$refs.table.$data.list.data;
          let entrances = data.map(d => d.entrance);
          let outputs = data.map(d => d.output);
          this.entrancesSum = entrances.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.outputsSum = outputs.reduce(function (a, b) {
            return a + b;
          }, 0);
          this.stock = data[data.length - 1].stock;
        }, 500);
      },
      selectProduct(prod) {
        this.product.id = prod.id;
        this.product.name = prod.productName;
        new BaseService('Patterns', '/GetProductPatterns/' + this.product.id).getList().then((response) => {
          var a = response.data;

          if (a.length === 0) {
            Utils.handleErrorWithNotification("هیچ الگویی برای این کالا تعریف نشده است", this.$noty);
            // console.log("هیچ الگویی برای این کالا تعریف نشده است");
          } else {
            this.productPattern = response.data;
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      openProductDetailModal(val) {
        // console.log(val)
        this.getKardex(val.id);
        this.$refs.selectProductModal.hide();
      },
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();
        /* if (this.$refs.productsContainer.hasChildNodes) {
             this.$refs.productsContainer.removeChild(
                 this.$refs.productsContainer.childNodes[0]
             );
         }*/
        // this.$refs.productsContainer.appendChild(_products.$el);
        // console.log(this.$refs.selectProductModal);
        if (this.$refs && this.$refs.selectProductModal) {
          // console.log("ok");
          // console.log(_products);

          this.$refs.selectProductModal.show();
        }
        _products.$on("onRowSelect", row => {
          this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getAllWorks() {
        this.isLoading = true;
        new BaseService('Works', '/WorksOfCompany').getList().then((response) => {
            this.isLoading = false;
            this.allWorks = response.data;
            // this.rows = this.allWorks.length;

            for (var i = 0; i < this.allWorks.length; i++) {
              switch (this.allWorks[i].workPriority) {
                case 0:
                  this.allWorks[i]['priorityName'] = "اولویت کم";
                  break;
                case 1:
                  this.allWorks[i]['priorityName'] = "اولویت متوسط";
                  break;
                case 2:
                  this.allWorks[i]['priorityName'] = "اولویت زیاد";
                  break;
              }
              switch (this.allWorks[i].status) {
                case 0:
                  this.allWorks[i]['statusName'] = "در انتظار تولید";
                  break;
                case 1:
                  this.allWorks[i]['statusName'] = "متوقف";
                  break;
                case 2:
                  this.allWorks[i]['statusName'] = "در حال تولید";
                  break;
                case 3:
                  this.allWorks[i]['statusName'] = "تولید شده";
                  break;
              }

            }

            this.rows = this.allWorks.length;
            // return Object.keys(counts).map(key => ({color: key, count: counts[key]}));

            // this.worksResultPagination = this.allWorks;
            this.nextPage(this.pageIndex);
          }
        ).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      // findSame(ar) {
      //   for (let i = 0; i < ar.length; i++) {
      //     if (ar[i].orderCode !== null) {
      //       for (let st = 0; st < 5; st++) {
      //         if (ar[i].status === st) {
      //           if (this.newWorkSystem.length === 0) {
      //             this.newWorkSystem.push(ar[i]);
      //             this.newWorkSystem[0].wcount = 1;
      //           } else {
      //             if (!this.findDataOrder(this.newWorkSystem, ar[i].orderCode, st)) {
      //               this.newWorkSystem.push(ar[i]);
      //               this.newWorkSystem[this.newWorkSystem.length-1].wcount = 1;
      //             }
      //           }
      //         }
      //       }
      //     }
      //     if (ar[i].productOrderCode !== null) {
      //       for (let st = 0; st < 5; st++) {
      //         if (ar[i].status === st) {
      //           if (this.newWorkSystem.length === 0) {
      //             this.newWorkSystem.push(ar[i]);
      //             this.newWorkSystem[0].wcount = 1;
      //           } else {
      //             if (!this.findDataProdOrder(this.newWorkSystem, ar[i].productOrderCode, st)) {
      //               this.newWorkSystem.push(ar[i]);
      //               this.newWorkSystem[this.newWorkSystem.length-1].wcount = 1;
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      //   console.log(this.newWorkSystem);
      //   return this.newWorkSystem;
      // },
      // findDataOrder(ar, ord, st) {
      //   let ret = false;
      //   for (let i = 0; i < ar.length; i++) {
      //     if (ar[i].orderCode === ord && ar[i].status === st) {
      //       ar[i].wcount = ar[i].wcount + 1;
      //       ret = true;
      //     }
      //   }
      //   this.newWorkSystem = ar;
      //   return ret;
      // },
      // findDataProdOrder(ar, ord, st) {
      //   let ret = false;
      //   for (let i = 0; i < ar.length; i++) {
      //     if (ar[i].productOrderCode === ord && ar[i].status === st) {
      //       ar[i].wcount = ar[i].wcount + 1;
      //       ret = true;
      //     }
      //   }
      //   this.newWorkSystem = ar;
      //   return ret;
      // },


      nextPage(index) {
        const nextIndex = (index - 1) * this.pageSize;
        this.worksResultPagination = this.allWorks.slice(nextIndex, nextIndex + this.pageSize);

        // let a = 0;
        // if (index == null) {
        //   this.pageIndex = 0;
        //   a = 0;
        // }
        // if (index <= 0) {
        //   this.pageIndex = 0;
        //   a = 0;
        // } else {
        //   this.pageIndex = index;
        //   a = index - 1;
        // }
        // new BaseService('Works', '/GetAllWorks' + '/' + a + '/' + this.pageSize + '/false').getList().then((response) => {
        //     this.allWorks = response.data.data;
        //     this.rows = response.data.count;
        //     this.worksResultPagination = this.allWorks;
        //
        //   }
        // ).catch((error) => {
        //   console.log(error)
        // });
      },
      getPatternsState(id) {
        new BaseService('Works', `/GetWorkStatesByWorkId/${id}`).getList().then((response) => {
            this.flowchartData = this.previewFlowchart(response.data);
          }
        ).catch((error) => {
          console.log(error)
        });
      },

      editNode(nodeId) {
        // alert(nodeId);
      },
      showChart(id) {
        this.getPatternsState(id);
        this.$refs['showWorkPattern'].show();
      },
      getStyle(status) {

        // for inQueue
        if (status === 0) {
          return 'fill: #FFC107,stroke: #FF8F00,stroke-width:3px'
        }

        // for problem
        if (status === 1) {
          return 'fill: #f44336,stroke:#c62828,stroke-width:3px'
        }

        // for doing
        if (status === 2) {
          return 'fill: #CDDC39,stroke:#9E9D24,stroke-width:3px'
        }

        // for done
        if (status === 3) {
          return 'fill: #03A9F4,stroke:#0277BD,stroke-width:3px'
        }

        // for confirm
        if (status === 4) {
          return 'fill:#4CAF50,stroke:#2E7D32,stroke-width:3px'
        }
      },
      previewFlowchart(stateItems) {

        const data = [];
        for (let s of stateItems) {
          data.push({
            id: `${s.id}`,
            text: s.companyName,
            edgeType: s.workState ? 'circle' : 'default',
            style: s.workState ? this.getStyle(s.workState.status) : '',
            next: stateItems.filter(si => si.preconditions.find(p => p === s.id)).map(si => si.id)
          });
        }
        return data;
      },
      showPatternChart(id) {
        // console.log(id)
      },
      /* rows() {
           return this.pagination.pageSize
       },*/
      /*  onWorksPaginationChange(pageIndex) {
            if (pageIndex) {
                this.pagination.pageIndex = pageIndex - 1;
                this.getAllWorks(this.pagination.pageIndex)
            }

        },*/

      onEditClicked(val) {
        // console.log(val.id)
      },
      checkNullable(val) {
        if (val) {
          return val
        } else {
          return "-"
        }
      },
      changeDateFormat(val) {
        let resultDate = ""
        if (val) {
          let date = Moment(val, "YYYY/MM/DD");
          resultDate = date.format("jYYYY/jMM/jDD");
          return resultDate
        } else {
          return "-"
        }
      },
      getUsers() {
        // this.isLoading = true;
        new BaseService('CompanyUserPost', '/GetCompanyUsers').getList().then((response) => {
          // console.log(response.data);
          this.users = response.data;
          if (this.users.length > 0) {
            for (const i of this.users) {
              i.name = i.user.firstName + " " + i.user.lastName;
            }
          }
          // this.isLoading = false;
        }).catch((error) => {
          // this.isLoading = false;
          console.log(error)
        })
      },
      userSelect(prop, data) {
        if (data !== null) {
          this.selectedUser = data.user;
          this.workReport.userId = data.user.id;
        }
      },

      toggleStartDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },

      setDateFromDatePicker(date) {
        console.log(date)
        if (this.dateClicked === 1) {
          this.startDate = date;
          this.workReport.start = date;
        }
        if (this.dateClicked === 2) {
          this.endDate = date;
          this.workReport.end = date;
        }

        // this.voucherModel.voucherDate = date;
      },
    },


    beforeMount() {

      // this.$router.push({
      //   path: "/customerWorks",
      //   // query: { id, _mode }
      // });
      // debugger;
      //   this.access = checkAccess(this.$route.path);
      // console.log(a);
      // this.hasAccess = !!this.options.access;

    },
    computed: {},
    watch: {}
  };
  // var vm = new Vue({
  //   el: '#app',
  //   data: {
  //     myArray: [ { color: 'red', number: '1' }, { color: 'red', number: '2' }, { color: 'red', number: '3' }, { color: 'red', number: '4' }, { color: 'blue', number: '5' }, { color: 'blue', number: '6' }, { color: 'blue', number: '7' }, { color: 'blue', number: '8' }, { color: 'blue', number: '9' }, { color: 'blue', number: '10' }, { color: 'blue', number: '11' }, { color: 'blue', number: '12' }, { color: 'blue', number: '13' }, { color: 'blue', number: '14' }, { color: 'green', number: '15' }, ],
  //     filteredArray:[]
  //
  //   },
  //   beforeMount(){
  //      // console.log(this.count(this.myArray));
  //   },
  //
  //   methods: {
  //     count(array) {
  //       //add 1 if the color exists, initialize as 1 if it does not
  //       let counts = array.reduce((out, {color}) => ({ ...out, [color]: out[color]+1 || 1}), {});
  //       return Object.keys(counts).map(key => ({color: key, count: counts[key]}));
  //     }
  //   }
  // });
</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
